import type { Action, Field, Form } from '@jmvdevelop/svelte-form';
import { addFieldOrRootError } from '$lib/validator/validatorUtils.js';

export function notBlank<TValues, TValue>(
    value: string | undefined | null,
    {
        form,
        field,
        message,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>;
        message: string;
    },
): Action<TValues, string> {
    if (value === '') {
        return addFieldOrRootError(form, field, message);
    }
    return (s) => s;
}

export function notNull<V, TValues, TValue>(
    value: V | undefined | null,
    {
        form,
        field,
        message,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>;
        message: string;
    },
): Action<TValues, string> {
    if (value == null) {
        return addFieldOrRootError(form, field, message);
    }
    return (s) => s;
}

export function notBlankAndNotNull<TValues, TValue>(
    value: string | undefined | null,
    {
        form,
        field,
        message,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>;
        message: string;
    },
): Action<TValues, string> {
    if (value === '' || value == null) {
        return addFieldOrRootError(form, field, message);
    }
    return (s) => s;
}

export function notEmpty<TValue, TValues, TFieldValue>(
    value: ArrayLike<TValue> | undefined | null,
    {
        form,
        field,
        message,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TFieldValue>;
        message: string;
    },
): Action<TValues, string> {
    if ((value?.length ?? 0) === 0) {
        return addFieldOrRootError(form, field, message);
    }
    return (s) => s;
}
